import {
  ConvertHTMLtoComponents,
  Spacer,
  Spacings,
} from "@polestar/component-warehouse-react";
import React from "react";

import { DescriptionList } from "../DescriptionList";

import {
  type DocumentAccordionRecord,
  type AccordionPanelTable,
} from "~/types";

interface Props {
  readonly body?: string;
  readonly table?: AccordionPanelTable;
  readonly isDeep?: boolean;
  readonly article?: DocumentAccordionRecord["article"];
}

/**
 * The Legal Accordion Panel component is used to display the content of an accordion panel.
 *
 * The content can be a body, a table or both.
 */
const AccordionPanel: React.FC<Props> = ({
  body,
  table,
  isDeep = false,
  article,
}) => {
  return (
    <React.Fragment key={article?.id}>
      {body && (
        <>
          <Spacer spacing={Spacings.xSmall} />
          <ConvertHTMLtoComponents data-testid="accordion-sub-panel-body">
            {body}
          </ConvertHTMLtoComponents>
          {isDeep && <Spacer spacing={Spacings.large} />}
        </>
      )}
      {table && (
        <>
          {!isDeep && <Spacer spacing={Spacings.large} />}
          <DescriptionList table={table} />
        </>
      )}
      <Spacer spacing={Spacings.large} />
    </React.Fragment>
  );
};

export default AccordionPanel;
